(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 let paused = reduced.matches;
 try {paused = paused || sessionStorage.getItem('sciesmic-motion-paused') === 'true';} catch {}
 const remember = () => {try {sessionStorage.setItem('sciesmic-motion-paused', String(paused));} catch {}};
 const controllers = new Set();
 const applyMotion = () => {
  document.documentElement.dataset.scMotionPaused = String(paused || reduced.matches);
  document.querySelectorAll('[data-sc-motion-toggle]').forEach(button => {
   button.hidden = false;
   button.setAttribute('aria-pressed', String(paused || reduced.matches));
   button.textContent = paused || reduced.matches ? 'Resume motion' : 'Pause motion';
   button.disabled = reduced.matches;
   if (reduced.matches) button.textContent = 'Reduced motion enabled';
  });
  document.dispatchEvent(new CustomEvent('sc:motion-change'));
  controllers.forEach(update => update());
 };
 const initialized = new WeakSet();
 const setup = (root = document) => {
  root.querySelectorAll('[data-sc-motion-toggle]').forEach(button => {
   if (initialized.has(button)) return;
   initialized.add(button);
   button.addEventListener('click', () => { paused = !paused; remember(); applyMotion(); });
  });
  root.querySelectorAll('[data-sc-showcase]').forEach(showcase => {
   if (initialized.has(showcase)) return;
   initialized.add(showcase);
   const tabs = [...showcase.querySelectorAll('[data-sc-material-tab]')];
   const panels = [...showcase.querySelectorAll('[data-sc-material-panel]')];
   const pauseButton = showcase.querySelector('[data-sc-showcase-pause]');
   if (!tabs.length || !panels.length || !pauseButton) return;
   let index = 0, localPause = false, visible = false, hovering = false, focused = false, timer;
   const show = (next, manual = false) => {
    index = (next + panels.length) % panels.length;
    showcase.dataset.scMaterialIndex = String(index);
    tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index));tab.tabIndex = i === index ? 0 : -1;});
    panels.forEach((panel, i) => panel.hidden = i !== index);
    if (manual) {localPause = true; update();}
   };
   const update = () => {
    clearTimeout(timer);
    if (!showcase.isConnected) {controllers.delete(update); return;}
    const stopped = paused || reduced.matches || localPause;
    pauseButton.setAttribute('aria-pressed', String(stopped));
    pauseButton.textContent = stopped ? showcase.dataset.resumeLabel : showcase.dataset.pauseLabel;
    pauseButton.disabled = reduced.matches;
    if (reduced.matches) pauseButton.textContent = 'Reduced motion enabled';
    const playing = !stopped && visible && !hovering && !focused && !document.hidden;
    showcase.dataset.scPlaying = String(playing);
    if (playing) timer = setTimeout(() => {show(index + 1); update();}, 6000);
   };
   showcase.classList.add('sc-showcase-ready');
   show(0);
   tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => show(i, true));
    tab.addEventListener('keydown', event => {
     let next;
     if (event.key === 'ArrowRight') next = index + 1;
     if (event.key === 'ArrowLeft') next = index - 1;
     if (event.key === 'Home') next = 0;
     if (event.key === 'End') next = tabs.length - 1;
     if (next === undefined) return;
     event.preventDefault();show(next, true);tabs[index].focus();
    });
   });
   pauseButton.addEventListener('click', () => {
    if (paused) {paused = false;localPause = false;remember();applyMotion();}
    else {localPause = !localPause;update();}
   });
   showcase.addEventListener('pointerenter', event => {if(event.pointerType === 'mouse'){hovering = true;update();}});
   showcase.addEventListener('pointerleave', () => {hovering = false;update();});
   showcase.addEventListener('focusin', () => {focused = true;update();});
   showcase.addEventListener('focusout', event => {focused = showcase.contains(event.relatedTarget);update();});
   document.addEventListener('visibilitychange', update);
   if ('IntersectionObserver' in window) new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;showcase.dataset.scInView = String(visible);update();
   },{threshold:.2}).observe(showcase);
   else visible = true;
   controllers.add(update);update();
  });
  root.querySelectorAll('.sc-curiosity-scene').forEach(scene => {
   if (initialized.has(scene)) return;
   initialized.add(scene);
   if ('IntersectionObserver' in window) new IntersectionObserver(entries => scene.dataset.scInView = String(entries[0].isIntersecting)).observe(scene);
   else scene.dataset.scInView = 'true';
  });
  applyMotion();
 };
 setup();
 document.addEventListener('shopify:section:load', event => setup(event.target));
 reduced.addEventListener('change', () => {if(reduced.matches) paused = true;applyMotion();});
})();
